import React from "react";
import CustomModal from "../common/customModal";

interface Props {
  show: boolean;
  onClose: () => void;
  heading?: string;
  message?: string;
  btnText?: string;
  renderIcon?: () => JSX.Element;
  onDelete?: () => void;
}

const DeleteModalV2: React.FC<Props> = ({
  show,
  onClose,
  heading = "Confirm Delete",
  message = "You want to delete all the marked items, this cant be undone once you delete.",
  btnText = "Yes, Delete",
  renderIcon,
  onDelete
}) => {
  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
    onClose();
  };

  const bodyContent = (
    <div className="text-center">
      <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
        {renderIcon ? renderIcon() : <i className="ti ti-trash-x fs-36" />}
      </span>
      <h4 className="mb-1">{heading}</h4>
      <p className="mb-3">{message}</p>
    </div>
  );

  const footerContent = (
    <div className="d-flex justify-content-center w-100">
      <button
        type="button"
        className="btn btn-light me-3"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-danger"
        onClick={handleDelete}
      >
        {btnText}
      </button>
    </div>
  );

  return (
    <CustomModal
      show={show}
      onClose={onClose}
      bodyContent={bodyContent}
      footerContent={footerContent}
      backdrop="static"
      dialogClassName="delete-modal-v2"
      hideHeader={true}
    />
  );
};

export default DeleteModalV2;
